<script>

export default {
  name: "WarningIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none" role="img" aria-label="Ícone de aviso">
    <title>Ícone de aviso</title>
    <path
      d="M8.51456 5.41118V8.51144M8.51456 11.6117H8.52232M16.056 12.3868L9.85547 1.53584C9.72027 1.29727 9.52421 1.09884 9.28729 0.960791C9.05037 0.822737 8.78106 0.75 8.50685 0.75C8.23264 0.75 7.96334 0.822737 7.72642 0.960791C7.4895 1.09884 7.29344 1.29727 7.15824 1.53584L0.957714 12.3868C0.821057 12.6234 0.749399 12.892 0.750004 13.1653C0.750609 13.4386 0.823456 13.7069 0.961161 13.943C1.09887 14.179 1.29653 14.3745 1.53413 14.5095C1.77172 14.6446 2.0408 14.7144 2.31408 14.712H14.7151C14.9871 14.7117 15.2542 14.6398 15.4896 14.5037C15.7251 14.3675 15.9205 14.1718 16.0564 13.9362C16.1923 13.7006 16.2637 13.4334 16.2637 13.1614C16.2636 12.8895 16.192 12.6223 16.056 12.3868Z"
      :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>